import script from "./CustomFieldEditPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomFieldEditPanel.vue?vue&type=script&setup=true&lang=js"

import "./CustomFieldEditPanel.vue?vue&type=style&index=0&id=1085abce&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1085abce"]])

export default __exports__